/**
 * 账号安全提示：进入 Main 拉取 getAccountSecurity，按后端布尔状态提示。
 * 后端只返回状态位，不返回密码；文案与跳转由前端映射。
 */

import { MessageBox } from 'element-ui'
import { getAccountSecurity } from '@/network/eqsys'
import '@/styles/weakPwdMessageBox.less'

const DISMISS_KEY = 'q7_security_alert_dismissed'

/** 状态 → 提示配置（按数组顺序优先展示一条；后续加状态只需追加项） */
const SECURITY_PROMPTS = [
  {
    flag: 'NeedChangePassword',
    title: '账号安全提醒',
    message: '检测到当前账号使用了初始弱密码，存在安全风险。建议立即修改密码，保障账号与数据安全。',
    confirmText: '去修改密码',
    cancelText: '稍后再说',
    action: 'change_password'
  }
  // 例：{ flag: 'NeedBindPhone', title: '...', action: 'bind_phone', ... }
]

function isTruthyFlag(v) {
  return v === true || v === 'true' || v === 1 || v === '1'
}

function isDismissedThisSession() {
  try {
    return sessionStorage.getItem(DISMISS_KEY) === '1'
  } catch (e) {
    return false
  }
}

function markDismissedThisSession() {
  try {
    sessionStorage.setItem(DISMISS_KEY, '1')
  } catch (e) {}
}

/** 退出登录时清除「稍后再说」会话标记 */
export function clearSecurityPromptSession() {
  try {
    sessionStorage.removeItem(DISMISS_KEY)
  } catch (e) {}
}

function goUserInfoPage(vm) {
  const item = {
    path: '/eq_userinfo',
    name: 'eq_userinfo',
    label: '个人中心',
    icon: 'icon-zhanghaoquanxianguanli',
    id: '7',
    url: 'userinfo/UserInfo',
    meta: {
      formname: 'userinfo',
      issys: '1'
    }
  }
  try {
    vm.$store.commit('selectMenu', item)
    return vm.$router.push({ name: item.name })
  } catch (e) {
    return vm.$router.push({ path: item.path }).catch(() => {})
  }
}

function resolveAction(vm, action) {
  if (action === 'change_password') {
    return Promise.resolve(goUserInfoPage(vm)).catch(() => {})
  }
  return Promise.resolve()
}

function pickPrompt(res) {
  for (let i = 0; i < SECURITY_PROMPTS.length; i++) {
    const item = SECURITY_PROMPTS[i]
    if (isTruthyFlag(res[item.flag])) return item
  }
  return null
}

function showSecurityPrompt(vm, prompt) {
  const messageHtml =
    '<div class="weak-pwd-card">' +
    '<div class="weak-pwd-icon" aria-hidden="true"><i class="el-icon-lock"></i></div>' +
    '<div class="weak-pwd-copy">' +
    '<h3 class="weak-pwd-title">' + prompt.title + '</h3>' +
    '<p class="weak-pwd-desc">' + prompt.message + '</p>' +
    '</div></div>'

  return MessageBox({
    title: '安全提示',
    message: messageHtml,
    dangerouslyUseHTMLString: true,
    customClass: 'weak-pwd-msgbox',
    showCancelButton: true,
    confirmButtonText: prompt.confirmText || '去处理',
    cancelButtonText: prompt.cancelText || '稍后再说',
    closeOnClickModal: false,
    distinguishCancelAndClose: true,
    showClose: true,
    center: false
  }).then(() => {
    return resolveAction(vm, prompt.action)
  }).catch(() => {
    markDismissedThisSession()
  })
}

/**
 * 进入主框架后按安全状态提示（本会话「稍后再说」后不再弹）
 */
export function checkAndPromptAccountSecurity(vm) {
  if (!vm || isDismissedThisSession()) return Promise.resolve()

  let usertoken = ''
  try {
    usertoken = vm.$utils.comjs.usertoken() || ''
  } catch (e) {
    return Promise.resolve()
  }
  if (!usertoken) return Promise.resolve()

  return getAccountSecurity({ usertoken }, { silentRefresh: true })
    .then((res) => {
      if (!res || res.Status !== 'ok') return
      const prompt = pickPrompt(res)
      if (!prompt) return
      return showSecurityPrompt(vm, prompt)
    })
    .catch(() => {})
}
